module.exports = __webpack_public_path__ + "img/aot_2.bc5468ee.gif";